import { ProjectCrystalDTO } from 'business/models/Models';
import React from 'react';
export interface CrystalInfoDetailPanelProps {
  crystalDetail: ProjectCrystalDTO;
}

const CrystalInfoDetailPanel = (props: CrystalInfoDetailPanelProps) => {
  const { crystalDetail } = props;
  const detailsArray = {
    Resolution: crystalDetail.resolution,
    Structure: crystalDetail.structure,
    'Data Collected': crystalDetail.dataCollected ? 'Yes' : 'No',
    'Date Frozen': crystalDetail.dateFrozen?.toLocaleDateString('en-US'),
    Soaking: crystalDetail.soaking,
  };

  const getContent = () => {
    const content = [];
    for (const [key, value] of Object.entries(detailsArray)) {
      content.push(
        <div id='crystalinfodetailpanel-content' style={{ color: '#808080' }}>
          {key}: {value}
        </div>,
      );
    }
    return content;
  };

  return <>{getContent()}</>;
};

export default CrystalInfoDetailPanel;
